export enum PblLiabilityPaymentStatusEnum {
  PAID = 'PAID',
  NOT_PAID = 'NOT_PAID',
  PENDING_PAYMENT = 'PENDING_PAYMENT',
  CANCELLED = 'CANCELLED',
  CANCELLED_PAID = 'CANCELLED_PAID'
}
